import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/feature/Logo';
import LanguageSelector from '@/components/feature/LanguageSelector';

const links: { label: string; to: string }[] = [
  { label: 'Home', to: '/' },
  { label: 'News', to: '/news' },
  { label: 'Tournaments', to: '/calendar' },
  { label: 'Community', to: '/community' },
  { label: 'Watch', to: '/watch' },
  { label: 'Pros', to: '/pros' },
  { label: 'Sponsors', to: '/partners' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const today = new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header className={`fixed top-0 inset-x-0 z-50 bg-background-50 transition-colors duration-300 ${solid ? 'border-b border-background-200' : ''}`}>
      <div className="flex items-center justify-between h-16 md:h-20 px-4 md:px-8">
        <Logo variant="lockup" className="mr-2 md:mr-6" />
        <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
          {links.map((l) => (
            <Link key={l.label} to={l.to} className="font-label font-semibold uppercase tracking-wider text-sm whitespace-nowrap cursor-pointer hover:text-primary-500 text-foreground-800 transition-colors">{l.label}</Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <span className="hidden 2xl:inline-flex items-center gap-2 font-label uppercase tracking-[0.18em] text-[11px] text-foreground-500 mr-2 whitespace-nowrap">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-2-line"></i></span>{today}
          </span>
          <LanguageSelector />
          <Link to="/#subscribe" className="bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold uppercase tracking-wider text-sm px-4 md:px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors">Subscribe</Link>
          <button type="button" onClick={() => setOpen(!open)} className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-950" aria-label="Menu" aria-expanded={open}>
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3 flex flex-col max-h-[calc(100vh-4rem)] overflow-y-auto">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="font-heading font-bold uppercase text-lg py-2.5 text-foreground-900 border-b border-background-200 cursor-pointer">{l.label}</Link>
          ))}
          <Link to="/demo-admin" onClick={() => setOpen(false)} className="font-heading font-bold uppercase text-lg py-2.5 text-secondary-700 cursor-pointer">Management preview</Link>
          <div className="pt-4">
            <p className="font-label uppercase tracking-widest text-[10px] font-bold text-foreground-500 mb-2">Reading language — preview</p>
            <LanguageSelector />
          </div>
        </nav>
      )}
    </header>
  );
}